import { useCallback, useState } from 'react'

type UseToggleCalendarType = {
  calendarType: 'daily' | 'monthly'
  toggleCalendar: () => void
}

const useToggleCalendarType = (initialState: 'daily' | 'monthly'): UseToggleCalendarType => {
  const [calendarType, setCalendarType] = useState<'daily' | 'monthly'>(initialState)
  const toggleCalendar = useCallback(() => {
    setCalendarType((prevState) => (prevState === 'daily' ? 'monthly' : 'daily'))
  }, [setCalendarType])
  return {
    calendarType,
    toggleCalendar,
  }
}

export default useToggleCalendarType
